import { Chart } from 'primereact/chart';
import React, { useEffect, useState } from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { ApiGet } from '../../helper/API/ApiData';
import { handleError } from '../../utils/helper';
import { DataTable } from 'primereact/datatable';
import { MdGroups } from 'react-icons/md';
import { GoLaw } from "react-icons/go";
import { useNavigate } from 'react-router-dom';

const EnterpriseDashboard = ({ showChart = true }: { showChart?: boolean }) => {
    const navigate = useNavigate()

    const [totalCount, setTotalCount] = useState({
        totalEnterprise: 0,
        totalIndividualEnterprise: 0,
        totalRegisteredEnterperise: 0,
        totalBusinessEnterprise: 0,
        totalAmountReceived: 0,
        totalProfitLoss: 0
    });

    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {

        ApiGet(`enterprise/dashboard`)
            .then((res: any) => {
                if (res?.status === 200) {
                    const documentStyle = getComputedStyle(document.documentElement);

                    setTotalCount(res.data[0].enterpriseData)

                    const labelList: string[] = []
                    const dataList: number[] = []

                    res.data[0].chart.enterpriseTypeChart.forEach((item: { count: number, type: string }) => {
                        dataList.push(item.count)
                        labelList.push(item.type)
                    })

                    const pieChartData = {
                        labels: labelList,
                        datasets: [
                            {
                                data: dataList,
                                backgroundColor: [
                                    documentStyle.getPropertyValue('--blue-500'),
                                    documentStyle.getPropertyValue('--yellow-500'),
                                    documentStyle.getPropertyValue('--green-500')
                                ],
                                hoverBackgroundColor: [
                                    documentStyle.getPropertyValue('--blue-400'),
                                    documentStyle.getPropertyValue('--yellow-400'),
                                    documentStyle.getPropertyValue('--green-400')
                                ]
                            }
                        ]
                    }

                    const options = {
                        plugins: {
                            legend: {
                                position: 'right',
                                padding: 10,
                                labels: {
                                    font: {
                                        size: 20,
                                        family: 'Arial',
                                        color: '#333' // custom color
                                    }
                                }
                            }
                        }
                    };

                    setChartData(pieChartData);
                    setChartOptions(options);
                }
            })
            .catch((error) => {
                handleError(error)
                return error
            })

    }, [])

    const gotoEnterprise = () => {
        navigate('/shgadmin/enterprise')
    }

    return (
        <Container fluid className="p-3">
            <h4 className="page-title">Enterprise Details</h4>
            <Row>
                <Col md={4}>
                    <Card style={{ cursor: "pointer" }} onClick={() => gotoEnterprise()}>
                        <Card.Body style={{ backgroundColor: '#609ea2' }}>
                            <Row>
                                <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <MdGroups style={{ fontSize: '2.5rem', color: '#fff' }} />
                                </Col>
                                <Col md={7} style={{ color: '#fff' }}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#fff' }}>No of Group Enterprises Formed</p>
                                        <h4 className="mb-0 card-title">{totalCount.totalEnterprise}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card style={{ cursor: "pointer" }} onClick={() => gotoEnterprise()}>
                        <Card.Body style={{ backgroundColor: '#28a745' }}>
                            <Row>
                                <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <i className="pi pi-user" style={{ fontSize: '2.5rem', color: '#fff' }}></i>
                                </Col>
                                <Col md={7} style={{ color: '#fff' }}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#fff' }}>No of Individuals Enterprises Formed</p>
                                        <h4 className="mb-0 card-title">{totalCount.totalIndividualEnterprise}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card style={{ cursor: "pointer" }} onClick={() => gotoEnterprise()}>
                        <Card.Body style={{ backgroundColor: '#141E46' }}>
                            <Row>
                                <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <i className="pi pi-briefcase" style={{ fontSize: '2.5rem', color: '#fff' }}></i>
                                </Col>
                                <Col md={7} style={{ color: '#fff' }}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#fff' }}>No of Enterprises Registered</p>
                                        <h4 className="mb-0 card-title">{totalCount.totalRegisteredEnterperise}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col md={4}>
                    <Card style={{ cursor: "pointer" }} onClick={() => gotoEnterprise()}>
                        <Card.Body style={{ backgroundColor: '#609ea2' }}>
                            <Row>
                                <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <i className="pi pi-id-card" style={{ fontSize: '2.5rem', color: '#fff' }}></i>
                                </Col>
                                <Col md={7} style={{ color: '#fff' }}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#fff' }}>No of Business</p>
                                        <h4 className="mb-0 card-title">{totalCount.totalBusinessEnterprise}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card style={{ cursor: "pointer" }} onClick={() => gotoEnterprise()}>
                        <Card.Body style={{ backgroundColor: '#28a745' }}>
                            <Row>
                                <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <i className="pi pi-database" style={{ fontSize: '2.5rem', color: '#fff' }}></i>
                                </Col>
                                <Col md={7} style={{ color: '#fff' }}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#fff' }}>Amount Received as Loan</p>
                                        <h4 className="mb-0 card-title">{totalCount.totalAmountReceived}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card style={{ cursor: "pointer" }} onClick={() => gotoEnterprise()}>
                        <Card.Body style={{ backgroundColor: '#141E46' }}>
                            <Row>
                                <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <GoLaw style={{ fontSize: '2.5rem', color: '#fff' }} />
                                </Col>
                                <Col md={7} style={{ color: '#fff' }}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#fff' }}>Profit / Loss Status</p>
                                        <h4 className="mb-0 card-title">{totalCount.totalProfitLoss}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>
            </Row>
            {showChart &&
                <Row className='mt-4'>
                    <Col md={12}>
                        <Card style={{}}>
                            <Card.Header>
                                <Card.Title>Enterprise Types</Card.Title>
                                <Card.Subtitle className="mb-2 text-muted">Enterprise types and the number of enterprises of each type</Card.Subtitle>
                            </Card.Header>
                            <Card.Body>
                                <Chart
                                    type="pie"
                                    data={chartData}
                                    options={{
                                        ...chartOptions, legend: {
                                            position: 'left'
                                        }
                                    }}
                                    style={{
                                        width: "auto",
                                        height: 500,
                                        display: 'flex',
                                        justifyContent: 'center'
                                    }}
                                    className=""
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            }

        </Container>
    )
}

export default EnterpriseDashboard